export default "__VITE_ASSET__2LdFo3k3__"